import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

/* MODAL */
import { useModal } from 'hooks/modalContext';
import CloseBtn from 'components/util/CloseModal';

/* JS */
import * as Server from 'assets/js/Server';
import * as Common from 'assets/js/Common';

const pestImgRenderer = CustomCellRendererProps => (
  <span className='imgSpanLogo'>
    {!Common.isEmpty(CustomCellRendererProps.data['pestImg']) && (
      <img
        alt={'PEST IMG'}
        src={CustomCellRendererProps.data['pestImg']}
      />
    )}
  </span>
);

const NfcHistoryModal = props => {
  const { closeModal } = useModal();

  const [gridRowData, setGridRowData] = useState([]);
  const [colDefs] = useState([{
    headerName: 'PatrolArea',
    field: 'patrolArea',
    minWidth: 100
  }, {
    headerName: 'TagTime',
    field: 'tagTime',
    minWidth: 100
  }, {
    headerName: 'Result',
    field: 'pestCheckResult',
    minWidth: 100
  }, {
    headerName: 'Img',
    field: 'pestImg',
    cellRenderer: pestImgRenderer,
    minWidth: 300,
    minHeight: 300
  }]);

  useEffect(() => {
    getPatrolNfcTagHistoryList();
  }, []);

  const getPatrolNfcTagHistoryList = () => {
    Server.sendGet('nfc/patrol/history', {
      fkCommuteSeq: props.props?.data.item?.commuteSeq,
      fkWorkerId: props.props?.data.item?.fkWorkerId
    }, getPatrolNfcTagHistoryListCallback).then();
  };

  const getPatrolNfcTagHistoryListCallback = res => {
    setGridRowData(res?.['resultList']);
  };

  return (
    <>
      <CloseBtn onClick={closeModal}/>

      <div className='modal-box nfc-modal'>
        <div className='inner'>
          <Title>
            <TitHead>
              <i/>
              <h4>NFC Tag History</h4>
            </TitHead>
          </Title>
          <ModalForm>
            <FormIn>
              <div className='nfc-container'>
                <ul className='nfc-header'>
                  {colDefs.map((col) => (
                    <li key={col.field}>{col.headerName}</li>
                  ))}
                </ul>
                <div className='nfc-viewport'>
                  <div className='nfc-content'>
                    {gridRowData.map((item, index) => (
                      <div className='nfc-row' key={index}>
                        {colDefs.map((col) => (
                          <div className='nfc-col' key={col.field}>
                            {col.field === 'pestImg' ? (
                              item[col.field] ? (
                                <img
                                  src={item[col.field]}
                                  alt='PEST IMG'
                                  style={{ width: '100%', height: 'auto' }}
                                  onClick={() => window.open(item[col.field], '_blank')}
                                />
                              ) : (
                                <span className='empty'/>
                              )
                            ) : (
                              item[col.field]
                            )}
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </FormIn>
            <FormBtn $Btn>
              <Btn onClick={closeModal}>Cancel</Btn>
            </FormBtn>
          </ModalForm>
        </div>
      </div>
    </>
  );
}

const Title = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TitHead = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;

  & i {
    display: block;
    width: 4px;
    height: 32px;
    border-radius: 0 2px 2px 0;
    background: #1e1e1e;
  }

  & h4 {
    font-weight: 700;
    font-size: 18px;
    color: #000000;
  }
`;

const ModalForm = styled.div`
  margin: 20px 0;
  position: relative;
  border-top: 1px solid #eeeeee;

  & > div + div {
    margin-top: 10px;
  }
`;

const FormIn = styled.div`
  position: relative;
  display: flex;
  gap: 10px 20px;

  .nfc-container {
    position: relative;
    width: 100%;

    .nfc-header {
      position: relative;
      width: 100%;
      display: flex;
      border-bottom: 1px solid #eeeeee;
      background: #f8f8f8;


      li {
        flex: 1;
        padding: 20px 0;
        font-weight: 700;
        font-size: 16px;
        text-align: center;
      }

      li:nth-child(2) {
        flex: 0.7;
      }

      li:nth-child(3) {
        flex: 1.3;
      }
    }

    .nfc-viewport {
      height: 500px;
      overflow: auto;

      .nfc-content {
        z-index: 1;
        position: relative;
        width: 100%;

        .nfc-row {
          display: flex;
          gap: 10px 10px;

          .nfc-col {
            white-space: pre-line;
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 400;
            font-size: 14px;
            text-align:center;

            img {
              width: 100%;
              max-height: 150px;
            }

            .empty {
              width: 100%;
              aspect-ratio: 1 / 1;
              background-color: #ffffff;
              display: flex;
              align-items: center;
              justify-content: center;
              max-height: 150px;
            }
          }

          .nfc-col:nth-child(2) {
            flex: 0.7;
          }

          .nfc-col:nth-child(3) {
            flex: 1.3;
            justify-content: center;
          }

        }
      }
    }
  }

  & select {
    width: calc(70% - 10px);
    height: 40px;
    line-height: 40px;
    padding: 0 16px;
    background: #f8f8f8 url('https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/sel_arrow.svg') top 50% right 10px no-repeat;
    border: 1px solid #cccccc;
    border-radius: 5px;
    outline: none;
    font-weight: 400;
    font-size: 15px;
    color: #000000;

    &:focus {
      border-color: #0072B9;
    }
  }

  & textarea {
    width: calc(70% - 10px);
    height: 150px;
    padding: 10px 16px;
    background: #f8f8f8;
    border-radius: 5px;
    border: 1px solid #cccccc;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    resize: none;
    outline: none;

    &:focus {
      border-color: #0072B9;
    }
  }
`;

const FormBtn = styled.div`
  margin-top: 25px !important;
  display: flex;
  align-items: center;
  gap: 0 8px;
`;

const Btn = styled.button`
  flex: 1;
  height: 40px;
  line-height: 40px;
  border-radius: 5px;
  background: ${props => (props['$Color'] ? '#0072b9' : '#a4a4a4')};
  font-weight: 500;
  font-size: 18px;
  color: #ffffff;
  text-align: center;

  &:hover {
    background-color: ${props => (props['$Color'] ? '#075C97' : '#7e7e7e')};
  }
`;

export default NfcHistoryModal;